class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink?.setAttribute("role", "button");
		cartLink?.setAttribute("aria-haspopup", "dialog");

		cartLink?.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});

		cartLink?.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	initSwiperHeaderCart() {
		console.log('from cart-drawer.js')
        const swiper_elem = document.querySelector('.ymal-swiper');
        if(swiper_elem != null) {
            new Swiper(swiper_elem, {
                slidesPerView: 'auto',
                spaceBetween: 12,
								a11y: false,
                breakpoints: {
                    1024: {
											slidesPerView: 3,
                    }
                },
                loop: false,
								pagination: {
                    el: ".ymal-navigation",
                    clickable: true
                },
            });
			// if(window.iWish){
			// 	window.iWish.init();
			// }
        }
    }

	open(triggeredBy) {
        const thisObj = this;
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);

		// here the animation doesn't seem to always get triggered. A timeout seem to help
		/* old function get ymal from product reccomendation
		setTimeout(() => {
			this.classList.add("animate", "active");
			fetch('/cart.js')
				.then(response => response.json())
				.then(cart => {
					return fetch(
					`/recommendations/products.json?product_id=${cart.items[0].product_id}&limit=6`
					);
				})
				.then(response => response.json())
				.then(data => {
					const products = data.products;
					if(products){
						if(products.length > 0) {
							const swiper_parent = document.querySelector('#ymal-products-wrapper');
							swiper_parent.innerHTML = "";
							const source = document.querySelector('.drawer__cart-items-wrapper');
							const target = document.querySelector('#ymal-slider');

							if (source && target) {
								target.style.width = source.offsetWidth + 'px';
							}
							
							// Create all product requests in parallel
							const productRequests = products.map(pro => 
								fetch(`/products/${pro.handle}?view=grid-cart-drawer-rec`)
								.then(res => {
									if (!res.ok) {
									throw new Error(`HTTP ${res.status}`);
									}
									return res.text(); // Shopify product view = HTML, not JSON
								})
								.then(html => html)
								.catch(error => {
									console.log(`Error loading product ${pro.handle}:`, error);
									return null; // same behavior as your axios version
								})
							);
							
							// Wait for all requests to complete
							Promise.all(productRequests)
								.then(results => {
									// Filter out failed requests and create slides
									const validResults = results.filter(result => result !== null);
									
									validResults.forEach(productHtml => {
										const slide_parent = document.createElement('div');
										slide_parent.classList.add("swiper-slide");
										slide_parent.innerHTML = productHtml;
										swiper_parent.appendChild(slide_parent);
									});
									
									// Initialize swiper after a short delay to ensure DOM is ready
									setTimeout(() => {
										thisObj.initSwiperHeaderCart();
										
										// Remove loading indicator
										const ymal_loading = document.querySelector('.ymal-loading');
										if(ymal_loading) {
											ymal_loading.remove();
										}
										
										// Show the section if we have products
										const ymal_elem = document.querySelector('.you-may-also-like');
										if(ymal_elem && validResults.length > 0) {
											ymal_elem.classList.remove('hide-m');
										}
									}, 500); // Reduced from 1500ms to 500ms
								})
								.catch(error => {
									console.log('Error loading recommended products:', error);
									
									// Remove loading indicator on error
									const ymal_loading = document.querySelector('.ymal-loading');
									if(ymal_loading) {
										ymal_loading.remove();
									}
								});
						}
					} else {
						const ymal_loading = document.querySelector('.ymal-loading');
						if(ymal_loading) {
							ymal_loading.remove();
						}
						const ymal_title = document.querySelector('.ymal-title');
						if(ymal_title) {
							ymal_title.remove();
						}
					}
				})
				.catch(err => {
					console.error(err);
				});
		});
		*/
		this.classList.add("animate", "active");
		setTimeout(() => {
			// Remove loading indicator
			const ymal_loading = document.querySelector('.ymal-loading');
			if(ymal_loading) {
				ymal_loading.remove();
			}
			
			// Show the section if we have products
			const ymal_elem = document.querySelector('.you-may-also-like');
			const ymal_elem_slide = ymal_elem.querySelectorAll('.swiper-slide');
			if(ymal_elem && ymal_elem_slide.length > 0) {
				ymal_elem.classList.remove('hide-m');
			}
			thisObj.initSwiperHeaderCart();
		},500)
		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("cart-overflow-hidden");
		let scrollY = window.scrollY;
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollY}px`;
		document.body.style.width = '100%';

		if (!isSafari()) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.add("overflow-clip");
		}
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("cart-overflow-hidden");
		const scrollY = Math.abs(parseInt(document.body.style.top || '0'));
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.width = '';

		window.scrollTo(0, scrollY);

		if (!isSafari()) {
			document.body.classList.remove("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-clip");
		}

		setTimeout(() => {
			let notification = this.querySelector(".notification");

			if (notification) {
				const activeItem = this.querySelector(
					`.cart-item[data-product-id="${this.productId}"`
				);
				notification.classList.remove("notification-open");
				activeItem?.classList.remove("active");
			}
		}, 1000);

		// Reset recommendations UI after drawer closes
		setTimeout(() => {
			// Hide the you-may-also-like section
			const ymalElem = document.querySelector('.you-may-also-like');
			if (ymalElem && !ymalElem.classList.contains('hide-m')) {
				ymalElem.classList.add('hide-m');
			}

			// Destroy announcement swiper if present
			const announcementSwiperEl = document.querySelector('.cart-announcement-swiper');
			if (announcementSwiperEl && announcementSwiperEl.swiper) {
				try {
					announcementSwiperEl.swiper.destroy(true, true);
				} catch (e) {
					console.warn('Failed to destroy announcement swiper on close', e);
				}
			}

			// Destroy you-may-also-like swiper and clear slides
			const ymalSwiperEl = document.querySelector('.ymal-swiper');
			if (ymalSwiperEl && ymalSwiperEl.swiper) {
				try {
					ymalSwiperEl.swiper.destroy(true, true);
				} catch (e) {
					console.warn('Failed to destroy ymal swiper on close', e);
				}
			}
			const swiperWrapper = document.querySelector('#ymal-slider');
			if (swiperWrapper) {
				// add loading indicator back if missing
				if (!swiperWrapper.querySelector('.ymal-loading')) {
					const loading = document.createElement('div');
					loading.className = 'ymal-loading';
					// optional inner markup for spinner
					loading.innerHTML = document.querySelector('.ymal-loading-storage').innerHTML;
					swiperWrapper.appendChild(loading);
				}
			}
		}, 300);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		let notification = this.querySelector(".notification");

		if (notification) {
			const activeItem = this.querySelector(
				`.cart-item[data-product-id="${this.productId}"`
			);
			notification.classList.add("notification-open");
			activeItem.classList.add("active");
		}

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"input",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}
